import MailFolderTableQuery from 'mini-mail-list-store/lib/store/schema/MailFolderTableQuery';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';
import { loadInitialConversationFromServer } from './loadInitialConversationFromServer';
import { loadInitialItemFromServer } from './loadInitialItemFromServer';
import { trace } from 'owa-trace';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

/**
 * @param tableView to load rows in
 * @param shouldPrefetchFirstNRows should prefetch reading-pane data for first N rows
 * @return a promise that resolves when the load table from server has completed
 */
export default action('loadInitialRowsFromServer')(function loadInitialRowsFromServer(
    tableView: TableView,
    shouldPrefetchFirstNRows: boolean
): Promise<void> {
    tableView.isLoading = true;
    if (tableView.isInitialLoadComplete && tableView.hasErrorLoadingTable) {
        tableView.isInitialLoadComplete = false;
    }
    tableView.hasErrorLoadingTable = false;
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            return loadInitialConversationFromServer(
                mailTableQuery,
                tableView,
                shouldPrefetchFirstNRows
            );

        case ReactListViewType.Message:
            return loadInitialItemFromServer(mailTableQuery, tableView, shouldPrefetchFirstNRows);

        default:
            trace.warn('listViewType: ' + tableView.tableQuery.listViewType + ' is not supported.');
            return Promise.resolve();
    }
});
